import React, { useEffect, useState } from "react";
import CuInput from "../../all-patient/components/CuInput";
import CuDropdown from "../../common_component/component/CuDropdown";
import CuButton from "../../all-patient/components/CuButton";
import { editProfileInputConfigs } from "../admin/sidebar/constant/Constant";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { toast } from "react-toastify";
import CuModal from "../../common_component/component/CuModal";
import Confirmation from "../../common_component/component/Confirmation";

const EditProfile = ({
  data,
  setFormData,
  formData,
  setOpenDeleteModal,
  openDeleteModal,
}) => {
  const [errors, setErrors] = useState({});
  const [clinic] = useAtom(clinicAtom);

  // //("data--------", JSON.stringify(data, null, 2));

  const handleInputChange = (e, key) => {
    setFormData({ ...formData, [key]: e.target.value });
  };

  const handleDropdownChange = (value, key) => {
    setFormData({ ...formData, [key]: value });
  };
  const editProfileMutation = useSecureUpdateItem(
    `${ApiEndPoint.USERS}doctor_personal_detail/`
  );

  const handleSubmit = () => {
    // Validate the form data
    // const newErrors = {};
    // editProfileInputConfigs.forEach(({ key, label }) => {
    //   if (!formData[key]) {
    //     newErrors[key] = `${label} is required`;
    //   }
    // });
    // setErrors(newErrors);

    // if (Object.keys(newErrors).length === 0) {
    // Perform submit action
    //("Form Data Submitted: ", formData);

    const payload = {
      action: "patchLoginDoctorDetails",
      backend: "True",
      clinic_id: clinic?.id,
      graduation_year: formData?.graduation_year,
      highest_qualification: formData?.highest_qualification,
      email: formData?.email,
      hospital_address: formData?.hospital_address,
      medical_registration_number: formData?.medical_registration_number,
      state: formData?.state,
      specialty: formData?.specialty,
      department: formData?.department,
      follow_up_period: formData?.follow_up_period,
      follow_up_fees: formData?.follow_up_fees,
    };

    editProfileMutation.mutate(
      { data: payload },
      {
        onSuccess: () => {
          toast.success("Update profile successfully");
        },
        onError: () => {
          toast.error("Something went wrong!");
        },
      }
    );
    // }
  };

  const deleteProfileMutation = useCreateItem(
    `${ApiEndPoint.USERS}delete_file/`
  );

  const handleDeleteProfile = () => {
    const payload = {
      file_names: [formData?.profile_img],
    };
    deleteProfileMutation.mutate(payload, {
      onSuccess: () => {
        const profilePayload = {
          action: "patchLoginDoctorDetails",
          backend: "True",
          clinic_id: clinic?.id,
          profile_img: "",
        };
        editProfileMutation.mutate(
          { data: profilePayload },
          {
            onSuccess: () => {
              toast.success("Profile Deleted Successfully");
              setOpenDeleteModal(false);
            },
            onError: () => {
              toast.error("Profile delete failed");
            },
          }
        );
      },
      onError: () => {
        toast.error("Profile delete failed");
      },
    });
  };

  return (
    <div className="pb-5 md:pb-1 relative">
      <div className="mt-7 px-4 md:mt-0 sm:w-3/4 w-full grid gap-2 grid-cols-1 lg:grid-cols-2 md:gap-2 md:grid-cols-1 lg:gap-2">
        {editProfileInputConfigs.map(({ label, key, type, options }) => (
          <div key={key} className="input-container">
            {type === "select" ? (
              <div>
                <div className="">{label}</div>
                <CuDropdown
                  options={options}
                  value={formData[key]}
                  onChange={(value) => handleDropdownChange(value, key)}
                  placeholder={`Select ${label}`}
                />
              </div>
            ) : (
              <div>
                <CuInput
                  label={label}
                  type={type}
                  placeholder={`Enter ${label}`}
                  value={formData[key] || ""}
                  onChange={(e) => handleInputChange(e, key)}
                />
                {errors[key] && (
                  <div className="mt-1 text-xs text-red-500">{errors[key]}</div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-7 w-3/4 sm:w-full grid lg:grid-cols-2 md:gap-2 md:grid-cols-1 lg:gap-2">
        <div className="w-full">
          <CuButton
            className="w-full h-[50px] rounded-[5px] border border-[#00000033] bg-[#C7EAC9]"
            onClick={handleSubmit}
            isLoading={editProfileMutation.isLoading}
          >
            Submit
          </CuButton>
        </div>
        <div className="w-full"></div>
      </div>
      {!!openDeleteModal && (
        <CuModal closeModal={() => setOpenDeleteModal(false)}>
          <Confirmation
            heading={"Delete Profile"}
            onClick={handleDeleteProfile}
            onCancel={() => setOpenDeleteModal(false)}
            loading={
              deleteProfileMutation.isLoading || editProfileMutation.isLoading
            }
          />
        </CuModal>
      )}
    </div>
  );
};

export default EditProfile;
